import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import * as React from 'react';
import { ComboRequestGq, ComboRequestGqProps } from '../../models/ComboRequestGq';

export default function useUpdateComboRequestGq() {
  const [mutation, mutationResult] = useMutation<ResponseGq, GqVariables>(gqTag);

  return React.useCallback(
    (command: UpdateComboRequestCommandGq) =>
      mutation({ variables: { command } }).then(
        (result) => result.data.projects.updateComboRequest.comboRequest
      ),
    []
  );
}

const gqTag = gql`
  mutation UpdateComboRequest($command: UpdateComboRequestCommand!) {
    projects {
      updateComboRequest(command: $command) {
        comboRequest {${ComboRequestGqProps}}
      }
    }
  }
`;

interface GqVariables {
  command: UpdateComboRequestCommandGq;
}

export interface UpdateComboRequestCommandGq {
  projectId: number;
  id: number;
  name: string;
  minSearchVolume: number;
  languageId?: number;
  languageName?: string;
  locationId?: number;
  locationName?: string;
  includeMonths: boolean;
  useComboTagging: boolean;
  wordGroups: WordGroupInputGq[];
  comboCombinations: ComboCombinationInputGq[];
}

export interface WordGroupInputGq {
  id: string;
  order: number;
  name: string;
  words: string;
}

export interface ComboCombinationInputGq {
  selected: boolean;
  wordGroups: string[];
  removeSpacing: number;
}

interface ResponseGq {
  projects: {
    updateComboRequest: {
      comboRequest: ComboRequestGq;
    };
  };
}
